import { expertWorkspaceWebSocketEventBus } from "@expert/websocket";
import { useEffect } from "react";

import { updatePrimaryProductSaleProgress } from "../utils/updatePrimaryProductSaleProgress";

export const useEnrollmentEventListener = () => {
    useEffect(() => {
        return expertWorkspaceWebSocketEventBus.on("ws_enrollment-event", updatePrimaryProductSaleProgress);
    }, []);
};
